"use client";
import { __rest } from '../../_virtual/_tslib.js';
import { jsx, Fragment } from 'react/jsx-runtime';

const BreadcrumbItem = (_a) => {
    var { ariaLabel, children, lastItem, selected = false, onClick, href, 'data-testid': testId = 'breadcrumb-item' } = _a, rest = __rest(_a, ["ariaLabel", "children", "lastItem", "selected", "onClick", "href", 'data-testid']);
    const onAnchorClick = (e) => {
        /* istanbul ignore else -- @preserve */
        if (e.type === 'click') {
            e.currentTarget.blur();
        }
        // reassign the target due to the hit area propogation
        const newEvent = e;
        newEvent.target = e.currentTarget;
        /* istanbul ignore else -- @preserve */
        if (onClick)
            return onClick(newEvent);
    };
    const anchorProps = Object.assign(Object.assign({}, rest), { 'aria-label': ariaLabel, role: href ? 'link' : 'button', tabIndex: 0, onClick: onAnchorClick });
    const renderLastSelected = () => {
        if (href)
            return (jsx(Fragment, { children: jsx("a", Object.assign({ href: "" }, anchorProps, { "data-testid": `${testId}-link`, "aria-current": "page", children: children })) }));
        return (jsx("button", Object.assign({}, anchorProps, { "data-testid": `${testId}-button`, "aria-current": "page", children: children })));
    };
    const renderAnchor = () => {
        /* istanbul ignore else -- @preserve */
        if (href)
            return (jsx("a", Object.assign({}, anchorProps, { href: href, "data-testid": `${testId}-link`, children: children })));
        return (jsx("button", Object.assign({}, anchorProps, { "data-testid": `${testId}-button`, children: children })));
    };
    return selected && lastItem ? renderLastSelected() : renderAnchor();
};

export { BreadcrumbItem, BreadcrumbItem as default };
